<script>
import professionalMixin from "@/mixins/accountable/professionalMixin";
import countdownMixin from "@/mixins/countdownMixin";
import orderMixin from "@/mixins/orderMixin";
import serverTimeMixin from "@/mixins/serverTimeMixin";

import ProgressBar from "@/components/_base/ProgressBar";

const MAX_TIME_TO_PAY = 1200;

export default {
  mixins: [professionalMixin, orderMixin, countdownMixin, serverTimeMixin],

  components: {
    ProgressBar
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    professional: function() {
      return this.order.professional;
    },

    currentState: function() {
      if (this.isOrderProvisioning(this.order)) {
        return "EM ANDAMENTO";
      }

      if (this.paid) {
        return this.isOrderOnPast ? "FALAR COM SUPORTE" : "LIMPEZA EM";
      }

      if (
        this.hasAPendingBoleto(this.order.payments) &&
        !this.canGoToCheckout(this.order)
      ) {
        return "AGUARDANDO CONFIRMAÇÃO";
      }

      if (this.inTimeToPay) {
        return "TEMPO RESTANTE";
      }

      return "CANCELADO";
    },

    paid: function() {
      return this.isOrderPaid(this.order);
    },

    daysLeft: function() {
      return this.daysBeforeOrder(this.order);
    },

    isOrderOnPast: function() {
      return this.daysLeft < 0;
    }
  },

  filters: {
    days(days) {
      if (days < 0) {
        return false;
      }

      if (days === 0) {
        return "HOJE";
      }

      return `${days} DIA${days > 1 ? "S" : ""}`;
    }
  },

  async mounted() {
    if (this.canGoToCheckout(this.order)) {
      await this.getServerTime();

      this.startCountDown(
        this.order.created_at,
        MAX_TIME_TO_PAY,
        this.serverTime
      );
    }
  }
};
</script>

<template>
  <div class="header">
    <div class="left">
      <img :src="professional | profilePicture" />

      <div class="header-content">
        <span class="name">
          {{ professional | firstName }}
        </span>

        <span class="order-count">
          <b>{{ professional | orderCount | minOrderCount }} limpezas</b> <span> realizadas</span>
        </span>
      </div>
    </div>

    <div class="right">
      <span class="text">{{ currentState }}</span>

      <div class="countdown">
        <div v-if="time">
          <span>{{ time }}</span>

          <ProgressBar :progress="percentageTimeLeft()" />
        </div>

        <div v-if="paid && !isOrderOnPast">
          <span>{{ daysLeft | days }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.left {
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.header > .left > img {
  width: 36px;
  height: 36px;
  margin-right: 8px;
  border-radius: 50%;
}

.header-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.header-content > .name {
  font-size: 16px;
  font-weight: 400;
}

.header-content > .order-count {
  font-size: 12px;
}

.header-content > .order-count > b {
  font-weight: 400;
  color: #603285;
}

.header-content > .order-count > span {
  display: none;
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.right > .text {
  font-size: 10px;
  font-weight: 500;
  text-align: end;
}

.right > .countdown {
  font-size: 16px;
  font-weight: 500;
}

@media (min-width: 360px) {
  .header-content > .order-count > span {
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Card/Header.vue